import { DOWNLOAD_FAILURE_REASONS } from '../../constants';
export const getFailureReason = ({ abortSignal, error, isPeerResponsive, isSending, isSendingEnd, }) => {
    if (abortSignal.aborted && error === abortSignal.reason) {
        return DOWNLOAD_FAILURE_REASONS.WORKER_TERMINATED;
    }
    if (!isSending) {
        return DOWNLOAD_FAILURE_REASONS.READ_FAILED;
    }
    if (!isPeerResponsive()) {
        return DOWNLOAD_FAILURE_REASONS.WORKER_UNRESPONSIVE;
    }
    return isSendingEnd
        ? DOWNLOAD_FAILURE_REASONS.END_FAILED
        : DOWNLOAD_FAILURE_REASONS.SEND_FAILED;
};
